import {GetterTree} from "vuex";
import {ReportsState} from "@/store/settings/reports/types";
import {RootState} from "@/store/types";

export const getters: GetterTree<ReportsState, RootState> = {
  reports:state => state.reports ?? [],
  reportStatusList:state => state.reportStatusList
}